'use strict';

(function () {
    angular
    .module('crewProfile')
    .component('userScheduleComponentCrewProfile', {
        templateUrl: 'profile/components/user-schedule-component.tpl.html',
            controller: function (EventManagerService, ContextMenuService, MessageService, CrewingSelectionHelper, crewingConstants, CrewingHelper, PopupManager, $timeout, $scope, crewSchAssignTraningLogic,applicationConstants) {
                var vm = this;
                vm.selectetRowIndex = null;
                vm.min_screen_width = 1000;
                //vm.roster_section_width = 900;

                vm.actual_screen_width = window.innerWidth;

                vm.roster_section_width = vm.actual_screen_width - 90;
                vm.day_width = Math.floor(vm.roster_section_width / 7 * 10) / 10;
                vm.minuteToPixelRatio = vm.day_width / (24 * 60);

                //vm.day_width = Math.floor(vm.roster_section_width / 7);
                vm.actual_screen_height = window.innerHeight - 330;
                vm.day_height = Math.floor(vm.actual_screen_height / 6);
                vm.block_height = Math.floor(vm.day_height * 35 / 100);
                vm.act_she_top_pos = vm.day_height - vm.block_height;
                vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;

                if (window.innerHeight === screen.height) {
                    vm.actual_screen_height = window.innerHeight - 160;
                }
                else {
                    vm.actual_screen_height = window.innerHeight - 275;
                }

                /*vm.actual_screen_height = window.innerHeight - 330; // 235 = header banners height + legend height
                vm.day_height = Math.floor(vm.actual_screen_height / 6);
                vm.block_height = Math.floor(vm.day_height * 35 / 100);
                vm.act_she_top_pos = vm.day_height - vm.block_height;
                vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;*/
                vm.calendar = [];
                vm.isBlockViewFlagEnable = false;
                vm.selectedDay = '';
                vm.selectedModul = null;
                vm.assignActionTypes = {
                    PAIRING: 'pairing',
                    EVENT: 'event',
                    TRAINING: 'training'
                };

                /*if (!!vm.actual_screen_width && vm.actual_screen_width > vm.min_screen_width) {
                    vm.roster_section_width = vm.actual_screen_width;
                    vm.day_width = Math.floor(vm.roster_section_width / 7 * 10) / 10;
                    vm.minuteToPixelRatio = vm.day_width / (24 * 60);
                }*/

                vm.menuActioRelatedContent = {
                    lastAction: null,
                    cut: {
                        cutActionSource: null
                    },
                    copy: {
                        copyActionSource: null
                    },
                    daySelection: {
                        selected: null
                    }
                };
                EventManagerService.registerEventListener(EventManagerService.EVENT.SCREEN_SIZE_CHANGE, changeScreenListener);
                //  CONTEXT_MENU Listener
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ADD_MEMO, addMemoListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EDIT_BLOCK, editBlockListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_EVENT, contextMenuAssignEventListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_OFF, onAssignOffListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_SICK_LEAVE, onAssignSickLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_ANNUAL_LEAVE, onAssignAnnualLeaveListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_BLOCK_DAYS, onAssignBlockDaysListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DELETE_BLOCK, deleteBlockListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_PAIRING, contextMenuAssignPairingListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ASSIGN_TRAINING, contextMenuAssignTrainingListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EMAIL_CREW, emailCrewScheduleListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.ALERT, sendAlertListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.HISTORY, historyListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.REGULATION_DETAILS, regulationDetailsListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DESELECT_ALL, deselectAll);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.EDIT_PAIRING, editPairingListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SMS, onSendSmsListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.PAX_MSG_DETAILS, paxMsgDetailsListener);

                //TOOLBAR Listener
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ADD_MEMO, addMemoListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.EDIT_BLOCK, editBlockListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ASSIGN_EVENT, toolbarAssignEventListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.DELETE_BLOCK, deleteBlockListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ASSIGN_PAIRING, toolbarAssignPairingListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ASSIGN_TRAINING, toolbarAssignTrainingListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.EMAIL_CREW, emailCrewScheduleListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.SMS, onSendSmsListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.ALERT, sendAlertListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.HISTORY, historyListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.REGULATION_DETAILS, regulationDetailsListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CREWING.EDIT_PAIRING, editPairingListener);

                EventManagerService.registerEventListener(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS, onCollapseAllExpandRows);




                vm.$onInit = function () {
                    setCrewScheduleBlockViewFlagsEnable();
                };

                vm.$onChanges = function (changeObj) {
                    if (changeObj.fromDate && changeObj.fromDate.currentValue && (changeObj.fromDate.currentValue != changeObj.fromDate.previousValue)) {
                        generateCalendar();
                    }
                    else if (changeObj.toDate && changeObj.toDate.currentValue && (changeObj.toDate.currentValue != changeObj.toDate.previousValue)) {
                        generateCalendar();
                    }
                    if (changeObj.crewActualSchedule && changeObj.crewActualSchedule.currentValue && (changeObj.crewActualSchedule.currentValue != changeObj.crewActualSchedule.previousValue)) {
                        generateCalendar();
                        adaptActualScheduleData();
                        CrewingSelectionHelper.crewNamesCol(vm.crewActualSchedule.nameCollection);
                        CrewingSelectionHelper.setCrewSchedule(vm.crewActualSchedule);
                        CrewingSelectionHelper.clearSelections();
                    }
                    if (changeObj.crewPublishSchedule && changeObj.crewPublishSchedule.currentValue && (changeObj.crewPublishSchedule.currentValue != changeObj.crewPublishSchedule.previousValue)) {
                        adaptPublishScheduleData()
                    }

                };
                vm.onBlockClick = function (day, actSchedule, eventDetails, week, rowIndex, event) {
                    vm.selectetRowIndex = week.rowIndex;
                    var context = {
                        crews: vm.crewDetails,
                        patterns: eventDetails,
                        block: actSchedule,
                        week: week
                    };
                    if (event.ctrlKey) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.CTRL_CLICK, context);
                    } else if (event.shiftKey) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.SHIFT_CLICK, context);
                    } else {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.SCHEDULE_BLOCK, CrewingSelectionHelper.INTERACTION.CLICK, context);
                    }
                    /*eventDetails.isSelected =true
                     CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.BLOCK, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
                     crews: vm.crewDetails,
                     block: actSchedule
                     });*/
                };
                vm.onBlockRightClick = function (childScope) {
                    vm.selectetRowIndex = childScope.$parent.rosterDay.rowIndex;
                    var pattern = childScope.$parent.day.actualSchedule[0];
                    if(childScope.$parent.day.actualSchedule.length > 1){
                    	pattern = childScope.$parent.day.actualSchedule[childScope.$parent.day.actualSchedule[0].length-1];
                    }
                    CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.SCHEDULE_BLOCK, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
                        crews: vm.crewDetails,
                        patterns: pattern,
                        block: childScope.actSchedule,
                        week: childScope.$parent.rosterDay
                    });

                };
                vm.onBlockHover = function (e, block) {
                    vm.blockToolTiop = block;
                    var findCheckPosition = function () {
                        var H = 'left', V = 'top';
                        if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                            H = 'left';
                        } else {
                            H = 'right';
                        }
                        if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                            V = 'bottom';
                        } else {
                            V = 'top';
                        }
                        return H + '-' + V;
                    };

                    vm.toolTipPosition = findCheckPosition();
                };

                function setCrewScheduleBlockViewFlagsEnable () {
                    CrewingHelper.getCrewScheduleBlockViewFlagsEnable(function (appParam) {
                        vm.isBlockViewFlagEnable = appParam && appParam.paramValue && (appParam.paramValue == 'Y');
                    });
                }

                function generateCalendar() {
                    vm.calendar = [];
                    vm.weekDays = moment.weekdaysShort(true);
                    vm.cal_start = moment(vm.fromDate, "DD/MM/YYYY");
                    vm.cal_end = moment(vm.toDate, 'DD/MM/YYYY');

                    var month = vm.cal_start.format('MM');
                    var year = vm.cal_start.format('YYYY');
                    var calenderEnd = '';
                    var calendarStart = moment('01/' + month + '/' + year, "DD/MM/YYYY");
                    var monthEnd = moment(vm.cal_start).endOf('month');
                    if (vm.cal_end.isAfter(monthEnd)) {
                        calenderEnd = vm.cal_end;
                    }
                    else {
                        calenderEnd = monthEnd;
                    }

                    //  var range = moment().range(vm.cal_start, vm.cal_end);

                    /* if (date.isBefore(endDate)
                     && date.isAfter(startDate)
                     || (date.isSame(startDate) || date.isSame(endDate))
                     ) {
                     alert("Yay!");
                     } else {
                     alert("Nay! :(");
                     }*/

//                    var diff=vm.cal_start.diff(vm.cal_end);
                    //var diff=calendarStart.diff(calenderEnd);

                    var dateDiff = calenderEnd.diff(calendarStart, 'days');
                    var tempCalendar = [];
                    var currDate = moment().format("DD/MM/YYYY");
                    for (var i = 0; i <= dateDiff; i++) {
                        var tmp = moment(calendarStart).add(i, 'd');
                        var isCurrentDate = (currDate === tmp.format('DD/MM/YYYY'));
                        var isDisable = true;
                        if (tmp.isBefore(vm.cal_end)
                            && tmp.isAfter(vm.cal_start)
                            || (tmp.isSame(vm.cal_start) || tmp.isSame(vm.cal_end))
                        ) {
                            isDisable = false;
                        }

                        tempCalendar.push({
                            date: tmp.format('DD/MM/YYYY'),
                            dayReference: tmp.format('YYYYMMDD'),
                            isSelected: false,
                            actualSchedule: [],
                            publishSchedule: [],
                            alertDetails: [],
                            memoDetails: [],
                            expiry: [],
                            isCurrentDate: isCurrentDate,
                            dayIndex: i,
                            isDisable: isDisable

                        });
                    }

                    var starIndex = vm.weekDays.indexOf(calendarStart.format('ddd'));
                    if (starIndex !== 0) {
                        for (var i = 0; i < starIndex; i++) {
                            tempCalendar.unshift({
                                date: 0,
                                dayReference: 0,
                                isSelected: false,
                                actualSchedule: [],
                                publishSchedule: [],
                                alertDetails: [],
                                memoDetails: [],
                                expiry: [],
                                isCurrentDate: false,
                                dayIndex: '',
                                isDisable: true

                            });
                        }
                    }
                    var endIndex = vm.weekDays.indexOf(calenderEnd.format('ddd'));
                    if (endIndex !== 6) {
                        for (var j = 0; j < (6 - endIndex); j++) {
                            tempCalendar.push({
                                date: 0,
                                dayReference: 0,
                                isSelected: false,
                                actualSchedule: [],
                                publishSchedule: [],
                                alertDetails: [],
                                memoDetails: [],
                                expiry: [],
                                isCurrentDate: false,
                                dayIndex: '',
                                isDisable: true
                            });
                        }

                    }
                    var t = 0;
                    vm.originalCal = angular.copy(tempCalendar)
                    for (var k = 0; k < tempCalendar.length; k += 7) {
                        var temp = [];
                        var j = 0;
                        for (j; j < 7; j++) {
                            temp.nextWeekStart = '';
                            temp.rowIndex = t;
                            temp[temp.length] = tempCalendar[k + j];
                            if (j === 0 && k !== 0) {
                                vm.calendar[t].nextWeekStart = tempCalendar[k + j].date;
                                t = t + 1;
                            }
                        }
                        vm.calendar[vm.calendar.length] = temp
                    }
                    CrewingSelectionHelper.setTimeLineDaysCol(vm.calendar);
                }

                function getPositionFromDate(date, time, relativeTo) {
                    var reqDate = date + ' ' + time;
                    var reqDateTime = moment(reqDate, 'DD/MM/YYYY HH:mm');
                    var relativeDate = moment(relativeTo, 'DD/MM/YYYY');
                    var diffFromStart = reqDateTime.diff(relativeDate, 'm');
                    return Math.round(diffFromStart * vm.minuteToPixelRatio);
                }

                function adaptActualScheduleData() {
                    // vm.crewSchedule = _.groupBy(vm.crewSchedule,'checkInDate');
                    mapScheduleWithCalendar();
                    mapAlertsWithCalendar();
                    mapMemosWithCalendar();
                    mapExpiryWithCalendar();
                }

                function mapScheduleWithCalendar() {
                	angular.forEach(vm.crewActualSchedule.schedule[0].adaptedRosterDutyDTOs, function (schedule, scheduleIndex) {
                		angular.forEach(vm.calendar, function (row, key) {
                			row.isExpand = false;
                			angular.forEach(row, function (day) {

                				if (schedule.patternStartDate === day.date) {

                					schedule.leftPos = getPositionFromDate(schedule.patternStartDate, schedule.patternStartTime, schedule.patternStartDate);
                					var endPos = getPositionFromDate(schedule.patternEndDate, schedule.patternEndTime, schedule.patternStartDate);
                					schedule.width = endPos - schedule.leftPos;
                					if (schedule.events.length) {
                						angular.forEach(schedule.events, function (event) {
                							if (event.type === "REST") {
                								event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, schedule.patternStartDate);
                								var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, schedule.patternStartDate);
                								event.width = endPos - event.leftPos;
                							}
                							else {
                								event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, schedule.patternStartDate);
                								var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, schedule.patternStartDate);
                								event.width = endPos - event.leftPos;
                							}


                						});
                					}
                					day.actualSchedule.push(schedule);

                					/*if (moment(schedule.patternEndDate, 'DD/MM/YYYY').diff(moment(row.nextWeekStart, 'DD/MM/YYYY')) >= 0 || moment(schedule.restEndDate, 'DD/MM/YYYY').diff(moment(row.nextWeekStart, 'DD/MM/YYYY')) >= 0) {
                                        if (vm.calendar[key + 1] !== undefined) {
                                            var tempSchedule = angular.copy(schedule);
                                            tempSchedule.leftPos = getPositionFromDate(tempSchedule.patternStartDate, tempSchedule.patternStartTime, row.nextWeekStart);
                                            var endPos = getPositionFromDate(tempSchedule.patternEndDate, tempSchedule.patternEndTime, row.nextWeekStart);
                                            tempSchedule.width = endPos - tempSchedule.leftPos;
                                            if (tempSchedule.events.length) {
                                                angular.forEach(tempSchedule.events, function (event) {
                                                    if (event.type === "REST") {
                                                        event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, row.nextWeekStart);
                                                        var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, row.nextWeekStart);
                                                        event.width = endPos - event.leftPos;
                                                    }
                                                    else {
                                                        event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, row.nextWeekStart);
                                                        var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, row.nextWeekStart);
                                                        event.width = endPos - event.leftPos;
                                                    }
                                                });
                                            }
                                            vm.calendar[key + 1][0].actualSchedule.push(tempSchedule);
                                        }
                                    }*/

                					for(var i = key;i< vm.calendar.length;i++){
                						var nextWeekStart = vm.calendar[i].nextWeekStart;
                						if (nextWeekStart!="" &&(moment(schedule.patternEndDate, 'DD/MM/YYYY').diff(moment(nextWeekStart, 'DD/MM/YYYY')) >= 0 || moment(schedule.restEndDate, 'DD/MM/YYYY').diff(moment(nextWeekStart, 'DD/MM/YYYY')) >= 0)) {
                							if (vm.calendar[i + 1] !== undefined) {
                								var tempSchedule = angular.copy(schedule);
                								tempSchedule.leftPos = getPositionFromDate(tempSchedule.patternStartDate, tempSchedule.patternStartTime, nextWeekStart);
                								var endPos = getPositionFromDate(tempSchedule.patternEndDate, tempSchedule.patternEndTime, nextWeekStart);
                								tempSchedule.width = endPos - tempSchedule.leftPos;
                								if (tempSchedule.events.length) {
                									angular.forEach(tempSchedule.events, function (event) {
                										if (event.type === "REST") {
                											event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, nextWeekStart);
                											var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, nextWeekStart);
                											event.width = endPos - event.leftPos;
                										}
                										else {
                											event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, nextWeekStart);
                											var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, nextWeekStart);
                											event.width = endPos - event.leftPos;
                										}
                									});
                								}
                								vm.calendar[i + 1][0].actualSchedule.push(tempSchedule);//set next week value
                							}
                						}
                					}
                				}
                				else {
                					if ((_.find(vm.originalCal, {date: schedule.patternStartDate}) === undefined) && schedule.patternEndDate === day.date && scheduleIndex === 0) {
                						schedule.leftPos = getPositionFromDate(schedule.patternStartDate, schedule.patternStartTime, day.date);
                						var endPos = getPositionFromDate(schedule.patternEndDate, schedule.patternEndTime, day.date);
                						schedule.width = endPos - schedule.leftPos;
                						if (schedule.events.length) {
                							angular.forEach(schedule.events, function (event) {
                								if (event.type === "REST") {
                									event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, day.date);
                									var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, day.date);
                									event.width = endPos - event.leftPos;
                								}
                								else {
                									event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, day.date);
                									var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, day.date);
                									event.width = endPos - event.leftPos;
                								}


                							});
                						}
                						day.actualSchedule.push(schedule);

                						for(var i = key;i> 0;i--){
                                            var previousWeekEnd = vm.calendar[i-1][6].date;
                                            if (previousWeekEnd!="" &&(moment(previousWeekEnd, 'DD/MM/YYYY').diff(moment(schedule.patternStartDate, 'DD/MM/YYYY')) >= 0 || moment(previousWeekEnd, 'DD/MM/YYYY').diff(moment(schedule.restStartDate, 'DD/MM/YYYY')) >= 0)) {
                                            	if (vm.calendar[i - 1] !== undefined) {
                                            		var tempSchedule = angular.copy(schedule);
                                                    tempSchedule.leftPos = getPositionFromDate(tempSchedule.patternStartDate, tempSchedule.patternStartTime, previousWeekEnd);
                                                    var endPos = getPositionFromDate(tempSchedule.patternEndDate, tempSchedule.patternEndTime, previousWeekEnd);
                                                    tempSchedule.width = endPos - tempSchedule.leftPos;
                                                    if (tempSchedule.events.length) {
                                                       angular.forEach(tempSchedule.events, function (event) {
                                                       if (event.type === "REST") {
                                                          event.leftPos = getPositionFromDate(event.restStartDate, event.restStartTime, previousWeekEnd);
                                                          var endPos = getPositionFromDate(event.restEndDate, event.restEndTime, previousWeekEnd);
                                                          event.width = endPos - event.leftPos;
                                                       }
                                                       else {
                                                            event.leftPos = getPositionFromDate(event.checkInDate, event.checkInTime, previousWeekEnd);
                                                            var endPos = getPositionFromDate(event.checkOutDate, event.checkOutTime, previousWeekEnd);
                                                            event.width = endPos - event.leftPos;
                                                       }
                                                       });
                                                    }
                                                    vm.calendar[i - 1][6].actualSchedule.push(tempSchedule);//set next week value
                                              }
                                           }
                                        }
                					}

                				}
                			});
                		});

                	});

                }

                function mapAlertsWithCalendar() {
                    angular.forEach(vm.calendar, function (row, key) {
                        angular.forEach(row, function (day) {
                            if (!!day.alertDetails) {
                                day.alertDetails = [];
                            }

                        });
                    });
                    angular.forEach(vm.alertsDetails, function (alert) {
                        angular.forEach(vm.calendar, function (row, key) {
                            angular.forEach(row, function (day) {
                                if (alert.alertDate === day.date) {
                                    day.alertDetails.push(alert);
                                }

                            });
                        });
                    });
                }

                function mapMemosWithCalendar() {
                    angular.forEach(vm.calendar, function (row, key) {
                        angular.forEach(row, function (day) {
                            day.memoDetails = [];
                        });
                    });
                    angular.forEach(vm.memoDetails, function (memo) {
                        angular.forEach(vm.calendar, function (row, key) {
                            angular.forEach(row, function (day) {
                                if (memo.memoDate === day.date) {
                                    var temp = day.memoDetails.indexOf(memo);
                                    day.memoDetails.push(memo);
                                }

                            });
                        });
                    });
                }

                function mapExpiryWithCalendar() {
                    angular.forEach(vm.calendar, function (row, key) {
                        angular.forEach(row, function (day) {
                            day.expiry = [];

                        });
                    });
                    angular.forEach(vm.crewDetails.crewExpiryDTOs, function (expiry) {
                        angular.forEach(vm.calendar, function (row, key) {
                            angular.forEach(row, function (day) {
                                if (expiry.dateOfExpiry === day.date) {
                                    day.expiry.push(expiry);
                                }

                            });
                        });
                    });
                }

                function adaptPublishScheduleData() {
                    angular.forEach(vm.crewPublishSchedule, function (schedule) {
                        angular.forEach(vm.calendar, function (row, key) {
                            angular.forEach(row, function (day) {
                                if (schedule.checkinDate === day.date) {
                                    schedule.leftPos = getPositionFromDate(schedule.checkinDate, schedule.checkinTime, schedule.checkinDate);
                                    var endPos = getPositionFromDate(schedule.checkOutDate, schedule.checkOutTime, schedule.checkinDate);
                                    schedule.width = endPos - schedule.leftPos;

                                    if (!!schedule.restStartDate) {
                                        schedule.restLeftPos = getPositionFromDate(schedule.restStartDate, schedule.restStartTime, schedule.checkinDate);
                                        var restEndPos = getPositionFromDate(schedule.restEndDate, schedule.restEndTime, schedule.checkinDate);
                                        schedule.restWidth = restEndPos - schedule.restLeftPos;
                                    }
                                    day.publishSchedule.push(schedule);
                                    if (moment(schedule.checkOutDate, 'DD/MM/YYYY').diff(moment(row.nextWeekStart, 'DD/MM/YYYY')) >= 0 || moment(schedule.restEndDate, 'DD/MM/YYYY').diff(moment(row.nextWeekStart, 'DD/MM/YYYY')) >= 0) {
                                        if (vm.calendar[key + 1] !== undefined) {
                                            var tempSchedule = angular.copy(schedule);
                                            tempSchedule.leftPos = getPositionFromDate(tempSchedule.checkinDate, tempSchedule.checkinTime, row.nextWeekStart);
                                            var endPos = getPositionFromDate(tempSchedule.checkOutDate, tempSchedule.checkOutTime, row.nextWeekStart);
                                            tempSchedule.width = endPos - tempSchedule.leftPos;

                                            if (!!tempSchedule.restStartDate) {
                                                tempSchedule.restLeftPos = getPositionFromDate(tempSchedule.restStartDate, tempSchedule.restStartTime, row.nextWeekStart);
                                                var restEndPos = getPositionFromDate(tempSchedule.restEndDate, tempSchedule.restEndTime, row.nextWeekStart);
                                                tempSchedule.restWidth = restEndPos - tempSchedule.restLeftPos;

                                            }
                                            vm.calendar[key + 1][0].publishSchedule.push(tempSchedule);
                                        }
                                    }
                                }
                            });
                        });
                    });
                }

                vm.clickOnMonthNavigation = function (option) {
                    vm.monthNavigation({'type': option})
                };

                vm.onMemoClick = function (memo) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.OPEN_MEMO, memo);
                };
                vm.onDaySelected = function (rosterDay, day, rowIndex, event) {
                    vm.selectedDay = day;
                    vm.selectetRowIndex = rosterDay.rowIndex;
                    var context = {
                        days: day,
                        crews: vm.crewActualSchedule.schedule[0],
                        crewNames: _.find(vm.crewActualSchedule.nameCollection, {crewId: vm.crewDetails.crewId}),
                        week: rosterDay
                    };
                    if (event.shiftKey) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.DAY, CrewingSelectionHelper.INTERACTION.SHIFT_CLICK, context);
                    } else if(event.ctrlKey) {
                    	CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.DAY, CrewingSelectionHelper.INTERACTION.CTRL_CLICK, context);
                    } else {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.SCHEDULE_DAY, CrewingSelectionHelper.INTERACTION.CLICK, context);
                    }

                    loadTrainings();
                };

                vm.onDayRightClick = function (clickedScope) {
                    vm.selectedDay = clickedScope.day;
                    vm.selectetRowIndex = clickedScope.$parent.rosterDay.rowIndex;
                    CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.SCHEDULE_DAY, CrewingSelectionHelper.INTERACTION.RIGHT_CLICK, {
                        days: clickedScope.day,
                        crews: vm.crewActualSchedule.schedule[0],
                        week: clickedScope.$parent.rosterDay
                    });
                };

                vm.cancelEvent = function (event) {
                    event.stopPropagation();
                };

                vm.getContextMenu = function (type, duty) {
                    /* if (type == 'duty') {
                     if (!!duty.patternId) {
                     return ContextMenuService.getContextMenu('DUTY_IN_PAIRING');
                     } else {
                     return ContextMenuService.getContextMenu('DUTY');
                     }
                     } else if (type == 'date') {
                     return ContextMenuService.getContextMenu('DATE');
                     }*/

                    var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();
                    var selectedDays = CrewingSelectionHelper.getSelectedDays();
                    var selectedCrews = CrewingSelectionHelper.getSelectedCrews();

                    /*if (!!vm.menuActioRelatedContent.cut.cutActionSource) {
                     return ContextMenuService.getContextMenu('CUT');
                     }

                     if (!!vm.menuActioRelatedContent.copy.copyActionSource) {
                     return ContextMenuService.getContextMenu('COPY');
                     }*/

                    if (type == 'duty') {
                        var showOrHide = duty.showInCrewPortal?'VISIBILITY_HIDE':'VISIBILITY_SHOW';
                        var visibilityMenu = (vm.isBlockViewFlagEnable) ?   ContextMenuService.getContextMenu(showOrHide) : [];
                        var otherMenu = [];

                        if(duty.illegalDistIdentifier){
                            otherMenu = ContextMenuService.getContextMenu('SHOW_VIOLATION');
                        }

                        if (selectedBlocks.length > 1) {
                            return ContextMenuService.getContextMenu('DELETE').concat(visibilityMenu).concat(otherMenu);
                        } else if (!!duty.patternId) {
                            return ContextMenuService.getContextMenu('SCHEDULE_DUTY_IN_PAIRING').concat(visibilityMenu).concat(otherMenu);
                        } else {
                            //return ContextMenuService.getContextMenu('SCHEDULE_DUTY');
                            if (CrewingHelper.isLeaveBlock(selectedBlocks[0])) {
                                return ContextMenuService.getContextMenu('SCHEDULE_LEAVE').concat(visibilityMenu).concat(otherMenu);
                            } else {
                                return ContextMenuService.getContextMenu('SCHEDULE_DUTY_IN_PAIRING').concat(visibilityMenu).concat(otherMenu);
                            }
                        }
                    } else if (type == 'date') {
                        if (selectedDays.length > 1) {
                            return ContextMenuService.getContextMenu('MULTIPLE_DAY_SELECTION');
                        }
                        return ContextMenuService.getContextMenu('DATE');
                    } else if (type == 'crew') {
                        if (selectedCrews.length > 1) {
                            return ContextMenuService.getContextMenu('MULTIPLE_CREW_SELECTION');
                        } else {
                            return ContextMenuService.getContextMenu('CREW');
                        }
                    }
                };

                function loadTrainings(selectedDate) {
                    crewSchAssignTraningLogic.loadTrainingsForCrew(
                        vm.crewDetails,
                        vm.selectedDay && vm.selectedDay.date,
                        vm.selectedDay && vm.selectedDay.date);
                };

                function addMemoListener() {
                    var _param = vm.selectedDay;
                    if (_param !== null) {
                        vm.onAddMemo.call(this, {params: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function editBlockListener() {
                    // var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                    var selectedDuty = CrewingSelectionHelper.getSelectedDuty();
                    var selectedWeek = CrewingSelectionHelper.getWeekData();

                    if (!!selectedDuty) {
                        var _param = {
                            duty: selectedDuty,
                            crew: vm.crewActualSchedule.schedule[0],
                            container: '#crewName_' + vm.crewDetails.crewId + '_' + vm.selectetRowIndex
                        };


                        if (!!_param.duty.eventId && !!_param.duty.blockDetailCount && _param.duty.blockDetailCount===1) {
                            if (_param.duty.updatableEvent) {
                                CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.WEEK, CrewingSelectionHelper.INTERACTION.EXPAND, {
                                    week: selectedWeek[0]
                                });
                                vm.isExpandName = true;
                                vm.onEditBlock.call(this, {params: _param});
                            } else {
                                MessageService.warning(MessageService.MESSAGES.CREWING.NOT_UPDATABLE_EVENT);
                            }
                        } else {
                            vm.onEditBlock.call(this, {params: _param});
                        }
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function onCollapseAllExpandRows() {
                    CrewingSelectionHelper.clearWeekRowExpands();

                    vm.isExpandName = false;
                }

                function contextMenuAssignEventListener() {
                    assignAction(vm.assignActionTypes.EVENT);
                }

                function toolbarAssignEventListener() {
                    assignAction(vm.assignActionTypes.EVENT);
                }

                function deleteBlock(param) {
                    if (!!param) {
                        var blocks = CrewingSelectionHelper.getSelectedBlocks();
                        var toBeDeleted = CrewingHelper.getDutyAndCrewCollectionFromSelectedBlocks(blocks);
                        vm.onBlockDelete({blocks: toBeDeleted});
                    }
                }

                function deleteBlockListener() {
                    var blocks = CrewingSelectionHelper.getSelectedBlocks();
                    if (blocks.length > 0) {
                        var details = {
                            title: 'Confirmation',
                            messages: ['Selected record will be Deleted. Do you wish to Continue?']

                        };
                        PopupManager.openModal('CONFIRM_DIALOG', details, deleteBlock);

                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function getContextMenuClickData() {
                    var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
                    var selectedDays = CrewingSelectionHelper.getSelectedDays();
                    var tmp = {
                        crewProfileId: selectedCrews[0].crewDTO.crewProfileId,
                        crewId: selectedCrews[0].crewId,
                      crewName: selectedCrews[0].crewDTO.firstName + ' ' + selectedCrews[0].crewDTO.lastName,
                      isOnProbation: selectedCrews[0].crewDTO.isOnProbation,
                        dateClicked: selectedDays[0].date,
                        isMultiple: false
                    };
                    if (selectedDays.length > 1) {
                        var sorted = _.sortBy(selectedDays, function (obj) {
                            return obj.dayIndex;
                        });
                        tmp.startDate = sorted[0].date;
                        tmp.endDate = sorted[sorted.length - 1].date;
                        tmp.isMultiple = true;
                    }
                    return tmp;
                }

                function getSelectedFirstDayAndFirstCrew() {
                    var daySelection = CrewingSelectionHelper.getSelectedDays();
                    var crewSelection = CrewingSelectionHelper.getSelectedCrews();

                    if (daySelection && daySelection.length > 0 && crewSelection && crewSelection.length > 0) {
                        var _params = {
                            day: daySelection[0],
                            crew: crewSelection[0]
                        };
                        return _params;
                    }
                    return null;
                }

                function onAssignOffListener(data) {
                    var _param = getContextMenuClickData(data);
                    vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.off})
                }

              function checkProbation(crewInfo, eventType) {
                if(crewInfo.isOnProbation == 'Y') {
                  var details = {
                    title: 'Confirmation',
                    messages: [MessageService.MESSAGES.CREWING.CREW_PROBATION_OVERRIDE,
                      "Crew Details:",
                      "Id:" + crewInfo.crewId,
                      "Name: " + crewInfo.crewName],
                    close : 'CLOSE'
                  };
                  PopupManager.openModal('CONFIRM_DIALOG', details, confirmAssignDirectAction);
                } else {
                  confirmAssignDirectAction('NO', eventType);
                }
              }

              function confirmAssignDirectAction(pass, eventType) {

                if(pass == 'CLOSE'){
                  return;
                }

                var isShowInCrewPortal = false;
                if (pass == 'YES') {
                  isShowInCrewPortal = true;
                }

                CrewingHelper.assignDirectEvent(
                  crewInfo.crewProfileId,
                  eventType,
                  stDate,
                  endDate,
                  false,
                  isShowInCrewPortal,
                  function (data) {
                    if (data.success) {
                      loadActualSchedule(false, undefined, 'Y');
                      switch (eventType) {
                        case crewingConstants.EVENT_TYPES.blockDays :
                        {
                          createLocalStorageVariable(param.crewId);
                          MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_BLOCK_DAYS_SUCCESS);
                          break;
                        }
                        case crewingConstants.EVENT_TYPES.off :
                        {
                          createLocalStorageVariable(param.crewId);
                          MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_OFF_SUCCESS);
                          break;
                        }
                        case crewingConstants.EVENT_TYPES.vulvLeave :
                        {
                          createLocalStorageVariable(param.crewId);
                          MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_VULV_SUCCESS);
                          break;
                        }
                        case crewingConstants.EVENT_TYPES.sickLeave :
                        {
                          createLocalStorageVariable(param.crewId);
                          MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_SICK_LEAVE_SUCCESS);
                          break;
                        }
                        case crewingConstants.EVENT_TYPES.annualLeave :
                        {
                          createLocalStorageVariable(param.crewId);
                          MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_ANNUAL_LEAVE_SUCCESS);
                          break;
                        }

                        case crewingConstants.EVENT_TYPES.cnt :
                      {
                        createLocalStorageVariable(param.crewId);
                        MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_CNT_SUCCESS);
                        break;
                      }

                        case crewingConstants.EVENT_TYPES.wfdLeave :
                        {
                          createLocalStorageVariable(param.crewId);
                          MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_WFD_LEAVE_SUCCESS);
                          break;
                        }

                        case crewingConstants.EVENT_TYPES.awbLeave :
                        {
                          createLocalStorageVariable(param.crewId);
                          MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_AWB_LEAVE_SUCCESS);
                          break;
                        }

                        case crewingConstants.EVENT_TYPES.limLeave :
                        {
                          createLocalStorageVariable(param.crewId);
                          MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_LIM_LEAVE_SUCCESS);
                          break;
                        }
                      }
                      //updateSelectedCrew([param.crewId]);
                      loadActualSchedule(false, undefined, 'Y');
                    }
                  },
                  function (error) {
                    MessageService.error(error);
                  },
                  param.isCustomSelectedDates,
                  param.customSelectedDates
                );
              }

                function onAssignSickLeaveListener(data) {
                    var _param = getContextMenuClickData(data);
                  checkProbation(_param);
                    vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.sickLeave})
                }

                function onAssignAnnualLeaveListener(data) {
                    var _param = getContextMenuClickData(data);
                    vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.annualLeave})
                }

                function onAssignBlockDaysListener(data) {
                    var _param = getContextMenuClickData(data);
                    vm.onDirectAction({param: _param, type: crewingConstants.EVENT_TYPES.blockDays})
                }

                function contextMenuAssignPairingListener() {
                    assignAction(vm.assignActionTypes.PAIRING);
                }

                function toolbarAssignPairingListener() {
                    assignAction(vm.assignActionTypes.PAIRING);
                }

                function contextMenuAssignTrainingListener() {
                    assignAction(vm.assignActionTypes.TRAINING);
                }

                function toolbarAssignTrainingListener() {
                    assignAction(vm.assignActionTypes.TRAINING);
                }

                function getSelectedDayAndCrew() {
                    var daySelection = CrewingSelectionHelper.getSelectedDays();
                    var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                    //var selectedDuty = CrewingSelectionHelper.getSelectedDuty();
                    var selectedWeek = CrewingSelectionHelper.getWeekData();

                    if (daySelection && daySelection.length > 0 && selectedWeek && selectedWeek.length > 0) {
                        var _params = {
                            day: daySelection,
                            crew: crewSelection,
                            week: selectedWeek
                        };
                        return _params;
                    }
                    return null;
                }

                function assignAction(type) {
                    var _params = getSelectedDayAndCrew();
                    if (_params !== null) {
                        CrewingSelectionHelper.performAction(CrewingSelectionHelper.ELEMENT_NAMES.WEEK, CrewingSelectionHelper.INTERACTION.EXPAND, {
                            crews: _params.crew[0],
                            week: _params.week[0]
                        });

                        _params.container = '#crewName_' + _params.crew[0].crewId + '_' + vm.selectetRowIndex;

                        vm.isExpandName = true;

                        switch (type) {
                            case vm.assignActionTypes.PAIRING :
                            {
                                vm.onAssignPairing({params: _params});
                                break;
                            }
                            case vm.assignActionTypes.TRAINING :
                            {
                                vm.onAssignTraining({params: _params});
                                break;
                            }
                            case vm.assignActionTypes.EVENT :
                            {
                                vm.onAssignEvent({params: _params});
                                break;
                            }
                        }

                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function emailCrewScheduleListener() {
                    if (!!vm.crewActualSchedule) {
                        var details = {
                            title: 'Confirmation',
                            messages: ['Do you want to send Crew Schedule as an Email?']

                        };
                        PopupManager.openModal('CONFIRM_DIALOG', details, emailSchedule);

                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function emailSchedule(param) {
                    if (!!param) {
                        var _param = {
                            crews: vm.crewActualSchedule.schedule[0]
                        };
                        vm.onEmailCrewSchedule.call(this, {params: _param});
                    }
                }

                function onSendSmsListener() {
                    var _param = getSelectedFirstDayAndFirstCrew();
                    if (_param !== null) {
                        vm.onSendSms.call(this, {param: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function sendAlertListener() {
                    var _param = getSelectedFirstDayAndFirstCrew();
                    if (_param !== null) {
                        vm.onSendAlert({param: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function historyListener() {
                    var _param = getSelectedFirstDayAndFirstCrew();
                    if (_param !== null) {
                        vm.onShowHistory.call(this, {params: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function regulationDetailsListener() {
                    var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                    var selectedDuty = CrewingSelectionHelper.getSelectedDuty();


                    if (!!selectedDuty) {
                        var _param = {
                            crew: crewSelection[0],
                            block: selectedDuty
                        };
                        vm.onShowRegulations.call(this, {params: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function paxMsgDetailsListener() {
                	var crewSelection = CrewingSelectionHelper.getSelectedCrews();
                    var selectedDuty = CrewingSelectionHelper.getSelectedDuty();


                    if (!!selectedDuty) {
                        var _param = {
                            crew: crewSelection[0],
                            block: selectedDuty
                        };
                        vm.onShowPaxMsgDet.call(this, {params: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }

				}

                function showAllCrewsInScheduleListener() {
                    var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();
                    if (selectedBlocks.length > 0) {
                        var _param = {
                            block: selectedBlocks[0]
                        };
                        vm.onShowAllCrewsInSchedule.call(this, {params: _param});
                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }
                }

                function deselectAll() {
                    CrewingSelectionHelper.clearSelections();
                }

                function editPairingListener() {
                    var selectedCrews = CrewingSelectionHelper.getSelectedCrews();
                    var selectedBlocks = CrewingSelectionHelper.getSelectedBlocks();
                    if (!!selectedCrews.length && !!selectedBlocks.length) {
                        /* var tmpParam = {
                         crew: selectedCrews[0],
                         block: selectedBlocks[0]
                         };
                         vm.onEditPairing({params: tmpParam});*/
                        if (selectedBlocks.length > 1) {
                            MessageService.warning(MessageService.MESSAGES.CREWING.OPERATION_NOT_SUPPORTED_FOR_MULTIPLE_BLOCKS);
                        } else {
                            var block = selectedBlocks[0];
                            if (!!block.patternId) {
                                var tmpParam = {
                                    crew: selectedCrews[0],
                                    block: selectedBlocks[0]
                                };
                                localStorage.setItem("crewList", tmpParam.crew.crewId);
                                vm.onEditPairing({params: tmpParam});
                            } else {
                                MessageService.warning(MessageService.MESSAGES.CREWING.BLOCK_NOT_PART_OF_A_PATTERN);
                            }
                        }

                    } else {
                        MessageService.warning(MessageService.MESSAGES.CREWING.NO_SELECTION_WARNING);
                    }


                }

                vm.moveOnExpiry = function (e, expiryDetails) {
                    var findCheckPosition = function () {
                        var H = 'left', V = 'top';
                        if ((e.clientX + e.target.offsetWidth + 100) > vm.screen_right_panel) {
                            H = 'left';
                        } else {
                            H = 'right';
                        }
                        if ((e.clientY + e.target.offsetHeight + 100) > vm.comHeight) {
                            V = 'bottom';
                        } else {
                            V = 'top';
                        }
                        return H + '-' + V;
                    };
                    vm.expiryToolTipModel = expiryDetails;
                    vm.expiryToolTipModel.placement = findCheckPosition();
                };
                vm.onExpiryClick = function (expiryDetails) {
                    var param = {
                        expiryInfo: {'EXPIRY': expiryDetails}
                    };
                    PopupManager.openModal('SHOW_EXPIRY', param);
                };

                $(window).resize(function(){
                	$timeout(function () {

            		vm.actual_screen_width = window.innerWidth;

                    vm.roster_section_width = vm.actual_screen_width - 90;
                    vm.day_width = Math.floor(vm.roster_section_width / 7 * 10) / 10;
                    vm.minuteToPixelRatio = vm.day_width / (24 * 60);

                    vm.actual_screen_height = window.innerHeight - 330;
                    vm.day_height = Math.floor(vm.actual_screen_height / 6);
                    vm.block_height = Math.floor(vm.day_height * 35 / 100);
                    vm.act_she_top_pos = vm.day_height - vm.block_height;
                    vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;

                    if (window.innerHeight === screen.height) {
                        vm.actual_screen_height = window.innerHeight - 160; // 120 = header banners height + legend height
                    }
                    else {
                        vm.actual_screen_height = window.innerHeight - 275; // 235 = header banners height + legend height
                    }
                    vm.day_height = Math.floor(vm.actual_screen_height / 6);
                    vm.block_height = Math.floor(vm.day_height * 35 / 100);
                    vm.act_she_top_pos = vm.day_height - vm.block_height;
                    vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;

                    vm.onScreenSizeChange.call(this);
                }, 500);

                });
                function changeScreenListener() {

                    $timeout(function () {

                        vm.actual_screen_height = window.innerHeight - 330;
                        vm.day_height = Math.floor(vm.actual_screen_height / 6);
                        vm.block_height = Math.floor(vm.day_height * 35 / 100);
                        vm.act_she_top_pos = vm.day_height - vm.block_height;
                        vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;

                        if (window.innerHeight === screen.height) {
                            vm.actual_screen_height = window.innerHeight - 160; // 120 = header banners height + legend height
                        }
                        else {
                            vm.actual_screen_height = window.innerHeight - 275; // 235 = header banners height + legend height
                        }
                        vm.day_height = Math.floor(vm.actual_screen_height / 6);
                        vm.block_height = Math.floor(vm.day_height * 35 / 100);
                        vm.act_she_top_pos = vm.day_height - vm.block_height;
                        vm.pub_she_top_pos = vm.act_she_top_pos - vm.block_height - 5;

                        vm.onScreenSizeChange.call(this);
                    }, 500);

                }
            },
            bindings: {
                fromDate: '<',
                toDate: '<',
                weekDays: '<',
                calendar: '<',
                monthNavigation: '&',

                crewActualSchedule: '<',
                alertsDetails: '<',
                memoDetails: '<',
                viewMode: '<',
                crewPublishSchedule: '<',
                crewDetails: '<',

                /*onAddMemo: '&',
                onEditBlock: '&',
                onAssignEvent: '&',
                onDirectAction: '&',
                onBlockDelete: '&',
                onAssignPairing: '&',
                onAssignTraining: '&',
                onEmailCrewSchedule: '&',
                onSendSms: '&',
                onSendAlert: '&',
                onShowHistory: '&',
                onShowRegulations: '&',
                onShowPaxMsgDet:'&',
                onShowAllCrewsInSchedule: '&',
                onEditPairing: '&',*/

                onScreenSizeChange : '&'
            }
        });
})();
